export const version = "strings/5.0.6";
//# sourceMappingURL=_version.js.map